<gridview  class="block" 
          [config]="config" 
          [title]="title" 
          [img]="img" 
          pk='CODEPRODUCT'
          [tableName]="table_name" 
          name="Meus Pedidos Melhor Envios"
          (rowContext)="clickedRow($event)" 
          [hidden]="editface"
          [options]="options"
          [columns]="columns">
  </gridview>